import { render, staticRenderFns } from "./outboundOrder.vue?vue&type=template&id=65695fc9&scoped=true&"
import script from "./outboundOrder.vue?vue&type=script&lang=ts&"
export * from "./outboundOrder.vue?vue&type=script&lang=ts&"
import style0 from "./outboundOrder.vue?vue&type=style&index=0&id=65695fc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65695fc9",
  null
  
)

export default component.exports